import { Component, OnInit } from '@angular/core';
import { AppelsService } from '../../service/appels.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-soumissions',
  templateUrl: './soumissions.component.html',
  styleUrls: ['./soumissions.component.css'],
})
export class SoumissionsComponent implements OnInit {
  email!: string;
  appelsBis!: any[];
  user!: any;

  constructor(private appelsservice: AppelsService) {}

  async ngOnInit() {
    this.user = sessionStorage.getItem('user');

    this.email = JSON.parse(this.user).email;

    this.appelsservice
      .getListSoumissions(this.email)
      .pipe(
        map((data) => {
          this.appelsBis = data.object;
        })
      )
      .subscribe();
  }

  /*  appels: any = [
    {
      title: 'Certificat Developpement logiciel',
      start: '21/09/2022',
      end: '22/12/2022',
      etat: 'Retenu'
    },
    {
      title: 'Certificat Animaition 3D',
      start: '21/09/2022',
      end: '22/12/2022',
      etat: 'En cours'
    },  
    {
      title: 'Certificat Dessin Digital',
      start: '21/09/2022',
      end: '22/12/2022',
      etat: 'Non Retenu'
    }



  ]; */
}
